import Axios from 'axios'
import { defaultSetting, interceptRequest, processResponse, processError } from '@/util/axios_common'

// 共通設定
const axios = Axios.create(defaultSetting)

// リクエストを送るときの共通処理
axios.interceptors.request.use((request) => {
  return interceptRequest(request, true)
})

// レスポンスを受け取ったときの共通処理
axios.interceptors.response.use((response) => {

  return processResponse(response, true)

}, error => {
  // interceptRequest()のトークンnullの場合のthrow Axios.Cancel()が実行された場合もここに飛んでくる

  processError(error)

})

export default axios
